import React, { Fragment } from 'react';

import Paper from '@material-ui/core/Paper';
import { Theme, withStyles, MuiThemeProvider } from "@material-ui/core/styles";
import { WithStyles } from '@material-ui/styles';
import { AppState, Actions, store, PanelState, IPageState } from '../../appredux';
import { connect } from 'react-redux';
import CONFIG from '../../cfg/config';
import { FcmNotification, PasscodeService, Result, RezerwacjaPobyt } from '../../api';
import { daysFromDate, sendErrorLog, selectTheme } from '../common/helpers';
import { Button, Grid, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Typography, TextField, Card, CardContent, CardActions, Link } from '@material-ui/core';
import { withTranslation, WithTranslation, TransProps, Trans } from 'react-i18next';
import Loader from 'app/common/loader/Loader';
import { ThemeOrange } from 'themes/themes';


interface ZamekOtworzProps extends WithStyles<typeof styles> {
  page: IPageState,
  open: boolean, 
  mode: number, // 0-obiekt  1-pokój 2-piętro 3-parking
  closePasscode: () => void,
  windowWidth: number,
  reservation: RezerwacjaPobyt
}

type ZamekOtworzState = {
    open: boolean,
    passcode: string,
    openPasscodeReturn: number,
    ladowanie: boolean,
}

const wciecie: string = '  * ';

class ZamekOtworz extends React.Component<ZamekOtworzProps & WithTranslation  & TransProps, ZamekOtworzState> {

  constructor(props: ZamekOtworzProps & WithTranslation  & TransProps) {
    super(props, {});

    this.state = {
      open: false,
      passcode: "",
      openPasscodeReturn: 0,
      ladowanie: false
    }
  }

  mode = (): boolean => {
    let from = new Date(this.props.reservation.pobyt_od)
    from.setHours(12)
    let to = new Date(this.props.reservation.pobyt_do)
    to.setHours(12)
    let now = new Date()

    console.log(from.getTime())
    console.log(from)
    console.log(this.props.reservation.pobyt_od)    
    console.log(to.getTime())
    console.log(to)
    console.log(this.props.reservation.pobyt_do)
    console.log(new Date().getTime())

    return from.getTime() > now.getTime() || to.getTime() < now.getTime()
    //return false
    // true -okno błędu dat    false - wpisanie hasła
  }

    async componentDidUpdate(prevProps: ZamekOtworzProps) {

        if(this.props.open && this.props.open !== prevProps.open ){

            if (this.mode()) {
                this.setState({ passcode: "", openPasscodeReturn: -2, ladowanie: false, open: false })
            } else {
                //okno do wpisania hasła
                if(this.props.mode ===  0 && CONFIG.menu1ObiektOtworz === "1" || this.props.mode ===  1 && CONFIG.menu1PokojOtworz === "1" || this.props.mode ===  2 && CONFIG.menu1PietroOtworz === "1" || this.props.mode ===  3 && CONFIG.menu1ParkingOtworz === "1" ){
                    this.setState({ open: true })
                //otwarcie bez hasła    
                } else if (this.props.mode ===  0 && CONFIG.menu1ObiektOtworz === "2" || this.props.mode ===  1 && CONFIG.menu1PokojOtworz === "2" || this.props.mode ===  2 && CONFIG.menu1PietroOtworz === "2" || this.props.mode ===  3 && CONFIG.menu1ParkingOtworz === "2") {
                    this.sendPasscodeWithoutPass()
                }
                
            }
 
        } else if ( !this.props.open && this.props.open !== prevProps.open ){
            this.setState({ open: false })
        }

       
    }


  sendPasscode = async () => {
    try {

        if(this.mode()){
            this.setState({ passcode: "", openPasscodeReturn: -2, ladowanie: false })
        } else {



        this.setState({ladowanie: true })

        let res : Result<number>
        let pass = this.state.passcode.toString().trim()
        if(pass[0] === "#"){ 
            pass = pass.substring(1, pass.length)
        }
        if(pass[pass.length -1] === "#"){ 
            pass = pass.substring(0, pass.length -1)
        }

        if(this.props.mode === 0) {
            res = await PasscodeService.obiektOtworz({
                aJSON: {
                    hotelId: CONFIG.hotelID,
                    passcode: pass
                }
            })

        } else if(this.props.mode === 1) {
            res = await PasscodeService.pokojOtworz({
                aJSON: {
                    hotelId: CONFIG.hotelID,
                    pobytId: this.props.reservation.pobyt_id.toString(),
                    passcode: pass
                }
            })

        } else if(this.props.mode === 2) {
            res = await PasscodeService.pietroOtworz1({
                aJSON: {
                    hotelId: CONFIG.hotelID,
                    pobytId: this.props.reservation.pobyt_id.toString(),
                }
            })

        } else if(this.props.mode === 3) {
            res = await PasscodeService.parkingOtworz1({
                aJSON: {
                    hotelId: CONFIG.hotelID,
                    pobytId: this.props.reservation.pobyt_id.toString(),
                }
            })

        } else {
            res = await {result: [0]}
        }





        if (res.result[0] > 0) {
            this.setState({ passcode: "", openPasscodeReturn: 1, ladowanie: false })
        } else {
            this.setState({ passcode: "", openPasscodeReturn: -1, ladowanie: false })
        }

        this.props.closePasscode();
           
        }

    } catch (error) {
        await sendErrorLog("0", "-1", `/vscZamki/ttlock/${this.props.mode === 0 ? "obiekt" : this.props.mode === 1 ? "pokoj" : this.props.mode === 2 ? "piętro" : "parking"}Otworz`)
        await store.dispatch(Actions.pageState.addFcmLogMessage(`/vscZamki/ttlock/${this.props.mode === 0 ? "obiekt" : this.props.mode === 1 ? "pokoj" : this.props.mode === 2 ? "piętro" : "parking"}Otworz`, 2))
        console.log(error)
        this.props.closePasscode();
        this.setState({ passcode: "", openPasscodeReturn: -1, ladowanie: false })
    }
}

    sendPasscodeWithoutPass = async () => {
        try {

            if (this.mode()) {
                this.setState({ passcode: "", openPasscodeReturn: -2, ladowanie: false, open: false })
            } else {
                this.setState({ ladowanie: true, open: false })

                let res: Result<number>

                if (this.props.mode === 0) {
                    res = await PasscodeService.obiektOtworz1({
                        aJSON: {
                            hotelId: CONFIG.hotelID,
                            pobytId: String(this.props.reservation.pobyt_id)
                        }
                    })

                } else if(this.props.mode === 1) {
                    res = await PasscodeService.pokojOtworz1({
                        aJSON: {
                            hotelId: CONFIG.hotelID,
                            pobytId: String(this.props.reservation.pobyt_id)
                        }
                    })

                } else if(this.props.mode === 2) {
                    res = await PasscodeService.pietroOtworz1({
                        aJSON: {
                            hotelId: CONFIG.hotelID,
                            pobytId: this.props.reservation.pobyt_id.toString(), 
                        }
                    })
        
                } else if(this.props.mode === 3) {
                    res = await PasscodeService.parkingOtworz1({
                        aJSON: {
                            hotelId: CONFIG.hotelID,
                            pobytId: this.props.reservation.pobyt_id.toString(),
                        }
                    })
        
                } else {
                    res = await {result: [0]}
                }



                if (res.result[0] > 0) {
                    this.setState({ passcode: "", openPasscodeReturn: 1, ladowanie: false })
                } else {
                    this.setState({ passcode: "", openPasscodeReturn: -1, ladowanie: false })
                }

                this.props.closePasscode();

            }

        } catch (error) {
            await sendErrorLog("0", "-1", `/vscZamki/ttlock/${this.props.mode === 0 ? "obiekt" : this.props.mode === 1 ? "pokoj" : this.props.mode === 2 ? "piętro" : "parking"}Otworz1`)
            await store.dispatch(Actions.pageState.addFcmLogMessage(`/vscZamki/ttlock/${this.props.mode === 0 ? "obiekt" : this.props.mode === 1 ? "pokoj" : this.props.mode === 2 ? "piętro" : "parking"}Otworz1`, 2))
            console.log(error)
            this.props.closePasscode();
            this.setState({ passcode: "", openPasscodeReturn: -1, ladowanie: false })
        }
    }

    getPasscode = (event: React.ChangeEvent<{ name?: string; value: unknown; }>) => {
        this.setState({ passcode: String(event.target.value) })
        //this.stylInputaRezerwacja = { ...this.stylInputaRezerwacja, backgroundColor: "rgb(232, 240, 254)" };
    }

    closePasscodeReturn = () => {
        this.props.closePasscode();
        this.setState({ openPasscodeReturn: 0 });
    };

  //PM 2021-08-06
  render() {
    const {classes, t} = this.props;
   
    let disabled = this.state.passcode === ""
    let tel = 'tel:'+ this.props.page.contact.kontaktGps

    return (      
        <Fragment>
            {this.state.ladowanie ? <Loader/> : null}
           
            <Dialog
                disableEscapeKeyDown
                maxWidth="xs"
                open={this.state.open}
                onClose={this.props.closePasscode}
                fullWidth
            >
                <DialogTitle disableTypography>
                    <Typography gutterBottom variant="h6" component="h2" color="primary">
                        <b><Trans>{this.props.mode === 0 ? "Open hotel" : this.props.mode === 1 ? "Open room" : this.props.mode === 2 ? "Open floor" : "Open parking" }</Trans></b>
                    </Typography>
                    <hr style={{ marginTop: "10px" }} />
                </DialogTitle>
                <DialogContent>
                    <DialogContentText className={classes.dialogContentText} >
                        <span ><Trans>Please enter your passcode</Trans></span>
                    </DialogContentText>
                    <TextField
                        id="zamowieniaTextField"
                        type="tel" //"number"
                        autoFocus
                        name="passcode"
                        //placeholder="* * * * * * * * *"

                        className={classes.floatLeft}
                        style={{ width: '100%' }}
                        variant="outlined"
                        inputProps={{ style: { backgroundColor: this.state.passcode ? this.props.page.secondaryLight : '#ffffff' } }}
                        InputProps={{ classes: { input: `${classes.black} ${classes.input}` } }}

                        value={this.state.passcode}
                        //defaultValue={this.state.passcode === 0 ? "" : this.state.passcode}
                        onChange={this.getPasscode}
                    //error={err}
                    //helperText={err ? "Niepoprawny numer telefonu" : ""}
                    />
                </DialogContent >
                <DialogActions >
                    <Button onClick={this.props.closePasscode} variant="outlined" size="small" color="primary"
                        style={{ textTransform: "none" }}
                    >
                        <b><Trans>Back</Trans></b>
                    </Button>
                    <Button
                        onClick={this.sendPasscode} disabled={disabled}
                        variant="contained" size="small" color="primary" style={{ textTransform: "none" }}
                    //disabled={this.state.rez_id.length > 0 ? false : true}
                    >
                        <b><Trans>Next</Trans></b>
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                disableEscapeKeyDown
                maxWidth="xs"
                open={this.state.openPasscodeReturn === 1}
                onClose={this.closePasscodeReturn}
                fullWidth
            >
                <DialogTitle disableTypography>
                    <Typography gutterBottom variant="h6" component="h2" color={"primary"} style={{ textTransform: "lowercase" }}>
                        <b><Trans>{"Success"}</Trans></b>
                    </Typography>
                    <hr style={{ marginTop: "10px" }} />
                </DialogTitle>
                <DialogContent>
                    <DialogContentText className={classes.dialogContentText} >
                        <span ><Trans>{this.props.mode === 3 ? "Door open parking" : "Door open"}</Trans></span>
                    </DialogContentText>

                </DialogContent >
                <DialogActions >
                    <Button onClick={this.closePasscodeReturn} variant="contained" size="small" color={"primary"}
                        style={{ textTransform: "none" }}
                    >
                        <b><Trans>Back</Trans></b>
                    </Button>
                </DialogActions>
            </Dialog>

            <MuiThemeProvider theme={ selectTheme(this.props.page.windowTheme) }>
            <Dialog
                disableEscapeKeyDown
                maxWidth="xs"
                open={this.state.openPasscodeReturn === -1}
                onClose={this.closePasscodeReturn}
                fullWidth
            >
                <DialogTitle disableTypography>
                    <Typography gutterBottom variant="h6" component="h2" color={"error"} style={{ textTransform: "lowercase" }}>
                        <b><Trans>{"Failure"}</Trans></b>
                    </Typography>
                    <hr style={{ marginTop: "10px" }} />
                </DialogTitle>
                <DialogContent>
                    <DialogContentText className={classes.dialogContentText} >
                        {this.props.mode ===  0 && CONFIG.menu1ObiektOtworz === "1" || this.props.mode ===  1 && CONFIG.menu1PokojOtworz === "1" ? <Trans>Wrong password</Trans> :
                        this.props.mode ===  3 && CONFIG.menu1ObiektOtworz === "2" ?  t("Door not open parking").slice(0, -1) : t("Door not open").slice(0, -1)}
                    </DialogContentText>
                    {/* <DialogContentText className={classes.dialogContentText} >
                   
                    </DialogContentText> */}
                    <DialogContentText className={classes.dialogContentText} >
                        {wciecie}<Typography component="span" color="secondary" ><b><Trans>Agin</Trans></b></Typography>
                    </DialogContentText>
                    <DialogContentText className={classes.dialogContentText} >
                        {wciecie}<Typography component="span" color="secondary" ><b><Trans>Phone Contact</Trans></b></Typography>
                    </DialogContentText>
                    <DialogContentText className={classes.dialogContentText} >
                        {wciecie}<Typography component="span" color="secondary" ><b><Trans>Phone</Trans>: <Link color='secondary' href={tel} >{this.props.page.contact.kontaktTelefon}</Link></b></Typography>
                    </DialogContentText>
                </DialogContent >
                <DialogActions >
                <MuiThemeProvider theme={ThemeOrange}>
                    <Button onClick={this.closePasscodeReturn} variant="contained" size="small" color="primary"
                        style={{ textTransform: "none" }}
                    >
                        <b><Trans>Back</Trans></b>
                    </Button>
                </MuiThemeProvider>
                </DialogActions>
            </Dialog>
            </MuiThemeProvider>

            <MuiThemeProvider theme={ selectTheme("5") }>
            <Dialog
                disableEscapeKeyDown
                maxWidth="xs"
                open={this.state.openPasscodeReturn === -2}
                onClose={this.closePasscodeReturn}
                fullWidth
            >
                <DialogTitle disableTypography>
                    <Typography gutterBottom variant="h6" component="h2" color={"error"} style={{ textTransform: "lowercase" }}>
                        <b><Trans>{"Warning"}</Trans></b>
                    </Typography>
                    <hr style={{ marginTop: "10px" }} />
                </DialogTitle>
                <DialogContent>
                    <DialogContentText className={classes.dialogContentText} >
                        <Trans>Open door</Trans>
                        </DialogContentText>
                    <DialogContentText className={classes.dialogContentText} >
                        {wciecie}<Trans>Booking</Trans> <Trans>From</Trans> <Typography component="span" color="error" ><b>{this.props.reservation.pobyt_od}</b></Typography>
                    </DialogContentText>
                    <DialogContentText className={classes.dialogContentText} >
                        {wciecie}<Trans>Booking</Trans> <Trans>To</Trans> <Typography component="span" color="error"  ><b>{this.props.reservation.pobyt_do}</b></Typography>
                    </DialogContentText>
                </DialogContent >
                <DialogActions >
                <MuiThemeProvider theme={ThemeOrange}>
                    <Button onClick={this.closePasscodeReturn} variant="contained" size="small" color="primary"
                        style={{ textTransform: "none" }}
                    >
                        <b><Trans>Back</Trans></b>
                    </Button>
                </MuiThemeProvider>
                </DialogActions>
            </Dialog>
            </MuiThemeProvider>
            
        </Fragment>
    );
  }
}

const styles = (theme: Theme) => ({
    rootPanel3: {
        textAlign: "left" as "left",
        overflowX: 'auto' as 'auto',
        maxWidth: '1286px',
        margin: 'auto',
        marginTop: "30px",
        //paddingTop: "15px",
        boxShadow: "0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)"
      },
    headline: {
        color: theme.palette.primary.main,
        lineHeight: "20px",
    },
    dialogContentText: {
        //color: theme.palette.text.secondary,
        color: "#555",
        //fontSize: "14px"
        whiteSpace: "break-spaces" as "break-spaces",
        minHeight: "24px"
    },
    cardContent: {
        paddingLeft: "24px",
        paddingRight: "24px",
        paddingBottom: "8px"
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    hr: {
        marginTop: '10px'
    },
    title: {
        padding: "0px"
    },
    lowercase: {
        textTransform: "lowercase" as "lowercase"
    },
    left: {
        textAlign: "left" as "left"
    },
    textSecondary: {
        color: theme.palette.text.secondary
    },
    backgroundWhite: {
        backgroundColor: "#ffffff"
    },
    fontWeightNormal: {
        fontWeight: "normal" as "normal"
    },
    cardActions: {
        flex: '0 0 auto',
        alignItems: 'center',
        justifyContent: 'flex-end',
    },
    primary: {
        color: theme.palette.primary.main,
    },

    floatLeft: {
        float: "left" as "left"
    },
    black: {
        color: "rgb(0, 0, 0)"
    },
    input: {
        padding: "8px 14px",
        fontWeight: 'normal' as 'normal',
        textAlign: 'left' as 'left'
    },
});

const mapStateToProps = (state: AppState) => ({
  page: state.pageState
});

export default connect(mapStateToProps)(withTranslation()(withStyles(styles)(ZamekOtworz)));